/* eslint-disable import/prefer-default-export, react/prop-types */
import React from 'react';
import MuiTheme from './MuiTheme'

export const wrapRootElement = ({ element }) => {
  return (<MuiTheme>{element}</MuiTheme>)
};